import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PartnerCreateInput } from "@colab/shared";

export type CreatePartnerResponse = { id: string };

// POST /api/partners
//
// Replaces revalidatePath("/admin/partners") + revalidatePath("/admin/dashboard")
// from /app/admin/partners/_actions.ts::createPartner. The PARTNER_ONBOARDED
// dispatch fires on the worker via c.executionCtx.waitUntil — no client
// concern.
export function useCreatePartner() {
  const queryClient = useQueryClient();
  return useMutation<CreatePartnerResponse, ApiClientError, PartnerCreateInput>({
    mutationFn: (input) =>
      apiFetch<CreatePartnerResponse>("/partners", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.list() });
      // Phase 7 sub-bucket 10 — admin list + dashboard ripple. New
      // partners can flip the `metrics.activePartners` counter when the
      // default status="active" lands.
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.partners.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.dashboard() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to create partner");
    },
  });
}
